import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import Messages from './Messages';
import SendMessage from './SendMessage';

import './Chat.css';

export default function Chat(props) {
    const { group } = props;

    const onSubmit = (values) => {
        props.handleSubmit(values);
    };

    return (
        <React.Fragment>
            <div className="chat-header d-flex justify-content-between align-items-center">
                <div className="user-details d-flex align-items-center">
                    <div className="d-lg-none ml-2">
                        <ul className="list-inline mt-2 mr-2">
                            <li className="list-inline-item">
                                <button
                                    className="btn text-muted px-0 left_side"
                                    onClick={props.closeConversation}
                                >
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                </button>
                            </li>
                        </ul>
                    </div>
                    <figure className="avatar ml-1">
                        <img className="rounded-circle" src={group.imageSrc} alt={group.name} />
                    </figure>
                    <div className="mt-1">
                        <h5 className="mb-1">
                            {group.name}
                        </h5>
                        <small className="text-muted mb-2">
                            {group.description}
                        </small>
                    </div>
                </div>
            </div>
            <div className="chat-body">
                {group.messages.length ? (
                    <Messages
                        group={group}
                        currentUser={props.currentUser}
                        triggerLoadMore={props.triggerLoadMore}
                        count={props.count}
                        sentMessage={props.sentMessage}
                        setSentMessage={props.setSentMessage}
                    />
                ) : (
                    <div className="messages d-flex justify-content-center">
                        <p className="m-3 p-3 text-muted">
                            There are no messages in this group.
                        </p>
                    </div>
                )}
            </div>
            <SendMessage
                groupId={group.id}
                currentUser={props.currentUser}
                onSubmit={onSubmit}
                onKeyUp={props.handleKeyUp}
            />
        </React.Fragment>
    );
}
